import { IFilterDrawerSchema } from '../components/FilterDrawer/types';
import { IFilterSchema } from '../components/interfaces';

type IconvertIntoMap = IterableIterator<[string, string]>;
export type IData = {
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  [key: string]: any;
};
type ISearchQuery = {
  [key: string]: string;
};

export const readQueryParams = (searchQuery: string = window.location.search): IData => {
  //url = https://localhost:3000/?pageNo*calling=10&dpdBucket*calling=10-20,50-100,300-999&pageSize*dataTable=100&showCol*filterTable=true
  // pageNo*calling=10&dpdBucket*calling=10-20,50-100,300-999&pageSize*dataTable=100&showCol*filterTable=true
  //here we are following key*table-ui
  const params = new URLSearchParams(searchQuery);
  const entries = params.entries();
  const data = convertIntoMap(entries);
  // output data
  //   {
  //     "calling": {
  //         "pageNo": "10",
  //         "dpdBucket": "10-20,50-100,300-999"
  //     },
  //     "dataTable": {
  //         "pageSize": "100"
  //     },
  //     "filterTable": {
  //         "showCol": "true"
  //     }
  // }
  return data;
};

// function specific to the queryParamHelper
// considering only 3 level of nesting

export const readNestedQueryParams = (): IData => {
  const searchQuery = window.location.search;
  const params = new URLSearchParams(searchQuery);
  const flattendQueryObjWithAsterik = Object.fromEntries(params);
  const data = unflattenObject(flattendQueryObjWithAsterik);
  return data;
};

const convertIntoMap = (entries: IconvertIntoMap): IData => {
  const iterableIterator = [...entries];
  return iterableIterator.reduce((prevValue: IData, currentValue) => {
    if (currentValue[0].includes('*')) {
      const [keyName, tableName] = currentValue[0].split('*');
      if (!prevValue[tableName]) {
        prevValue[tableName] = {};
      }
      prevValue[tableName][keyName] = decodeURIComponent(currentValue[1]);
      return prevValue;
    }
    prevValue[currentValue[0]] = decodeURIComponent(currentValue[1]);
    return prevValue;
  }, {});
};

const unflattenObject = obj =>
  Object.keys(obj).reduce((res, k) => {
    k.split('*')
      .reverse()
      .reduce(
        (acc, e, i, keys) =>
          acc[e] ||
          (acc[e] = isNaN(Number(keys[i + 1])) ? (keys.length - 1 === i ? obj[k] : {}) : []),
        res
      );
    return res;
  }, {});

// Converts a leaf value to its URL string form, or null to skip empty/invalid values.
const toQueryLeafString = (val: unknown) => {
  if (val === undefined || val === null) return null;
  if (typeof val === 'number') return Number.isFinite(val) ? String(val) : null;
  if (typeof val === 'boolean') return String(val);
  return val.length > 0 ? val : null;
};

export const createQueryParams = (data: IData): string => {
  const params: ISearchQuery = flattenObject(data, '*');
  const searchParam = new URLSearchParams();
  Object.keys(params).forEach(value => {
    const [tableName, param] = value.split('*');
    const encodedValue = toQueryLeafString(params[value]);
    if (!encodedValue) return;
    searchParam.set(`${param}*${tableName}`, encodeURIComponent(encodedValue));
  });
  return '?' + searchParam.toString();
  // history.pushState(null, '', '?' + searchParam.toString());
};

export const createNestedQueryParams = (data: IData): string => {
  const params: ISearchQuery = flattenObject(data, '*');
  const searchParam = new URLSearchParams();
  Object.keys(params).forEach(value => {
    const [tableName, param, subProperty] = value.split('*');
    const encodedValue = toQueryLeafString(params[value]);
    if (!encodedValue) return;
    const modifiedSubProperty = subProperty ? subProperty + '*' : '';
    searchParam.set(
      `${modifiedSubProperty}${param}*${tableName}`,
      encodeURIComponent(encodedValue)
    );
  });
  return '?' + searchParam.toString();
};

export const getTableQueryParams = (
  filterSchema: Record<string, IFilterSchema | IFilterDrawerSchema>,
  tableName: string,
  checkForNestedFilters = false
) => {
  const { [tableName]: tableQueryParams } = readQueryParams();
  if (!tableQueryParams) {
    return;
  }
  Object.keys(filterSchema).forEach(key => {
    if (filterSchema[key]) {
      tableQueryParams[key] = tableQueryParams[key]?.split(',') || [];
    }
    if (checkForNestedFilters) {
      const isNestedFilter = filterSchema[key]?.nestedFilter;
      if (isNestedFilter) {
        Object.keys(tableQueryParams).forEach(param => {
          if (param.includes(key)) {
            const nestedFilterKey = param.split('_')[1];
            if (nestedFilterKey) {
              if (tableQueryParams[param]) {
                tableQueryParams[key] = {
                  ...(tableQueryParams[key] || {}),
                  [nestedFilterKey]: tableQueryParams[param]?.split(',') || []
                };
              }
              delete tableQueryParams[param];
            }
          }
        });
      }
    }
  });
  return tableQueryParams;
};

const flattenObject = (data: IData, separator = '.', newData: ISearchQuery = {}, key = '') => {
  const separatorValue = key === '' ? '' : separator;
  Object.keys(data).forEach(value => {
    if (typeof data[value] === 'object' && !Array.isArray(data[value])) {
      return flattenObject(data[value], separator, newData, key + separatorValue + value);
    }
    newData[key + separatorValue + value] = data[value];
  });
  return newData;
};
